import React, { Component } from "react";
import "../../css/theme/bootstrap.css";
import "../../css/theme/custom.css";
import "../../css/bootstrap-float-label.min.css";
import MainMenu from "../../Components/Common/MainMenu";
import Header from "../../Components/Shared/Header";
import NavigationBar from "../../Components/Shared/NavigationBar";
import TitleAndMetaTags from "../../Components/Common/TitleAndMetaTags";
import Main from "./Main";
import Footer from "../../Components/Shared/Footer";
import {
  GetLoggedInUserApi,
  GetCartApi,
  LogoutUserApi,
  ShowFreeHolidayShipping,
} from "../../Code/Data";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: null,
      shoppingCart: null,
      userLogout: null,
      isLoading: true,
    };
  }

  async componentWillMount() {
    let currentUser = null,
      shoppingCart = null;
    const userApi = await GetLoggedInUserApi(),
      shoppingCartApi = await GetCartApi(),
      showFreeHolidayShipping = await ShowFreeHolidayShipping(),
      refreshShoppingCart = async () => {
        let shoppingCartApi = await GetCartApi();
        if (shoppingCartApi.Succeeded) {
          let shoppingCart = shoppingCartApi.ShoppingCart;
          this.setState({ shoppingCart });
        }
      },
      userLogout = async () => {
        const logoutApi = await LogoutUserApi();
        if (logoutApi.Succeeded) {
          let shoppingCart = null;
          const cartApi = await GetCartApi();
          if (cartApi.Succeeded) {
            shoppingCart = cartApi.ShoppingCart;
          }
          this.setState({ currentUser: null, shoppingCart });
        }
      };
    if (userApi.Succeeded) {
      currentUser = userApi.User;
    }
    if (shoppingCartApi.Succeeded) {
      shoppingCart = shoppingCartApi.ShoppingCart;
    }

    this.setState({
      currentUser,
      shoppingCart,
      userLogout,
      refreshShoppingCart,
      isLoading: false,
      showFreeHolidayShipping,
    });
  }

  render() {
    return (
      <div className="App">
        <TitleAndMetaTags />
        <Header {...this.state} />
        <div className="d-none d-md-block">
          <NavigationBar {...this.state} />
        </div>
        <div className="d-md-none">
          <MainMenu block {...this.state} />
        </div>
        <Main {...this.state} />
        <Footer {...this.state} />
      </div>
    );
  }
}
